import { useHistory } from 'react-router';

import { MDText } from 'i18n-react';

import { Button, CameraFrameIcon, InspectIcon, SunIcon } from '@motorway/mw-highway-code';

import { RecommendedPhotoTips } from 'Storybook/components/local/RecommendedPhotoTips/RecommendedPhotoTips';

import { IncodeFooter } from '../components/IncodeFooter';
import { IncodeHeader } from '../components/IncodeHeader';
import { INCODE_ANALYTICS } from '../IncodeAnalytics';

import LocalTexts from './Incode.texts.json';

import styles from './IncodeStart.module.scss';

const LocalT = new MDText(LocalTexts.start);

const content = [
  {
    icon: InspectIcon,
    recommendation: `${LocalT.translate('tips.1.description')}`,
    recommendationTitle: `${LocalT.translate('tips.1.title')}`,
  },
  {
    icon: CameraFrameIcon,
    recommendation: `${LocalT.translate('tips.2.description')}`,
    recommendationTitle: `${LocalT.translate('tips.2.title')}`,
  },
  {
    icon: SunIcon,
    recommendation: `${LocalT.translate('tips.3.description')}`,
    recommendationTitle: `${LocalT.translate('tips.3.title')}`,
  },
];

const CTA = LocalT.translate('cta') as string;

export const IncodeStart = () => {
  const history = useHistory();

  return (
    <div className={styles.component}>
      <IncodeHeader instructions={LocalT.translate('instructions')} title={LocalT.translate('title')} />
      <RecommendedPhotoTips data-incode-tips showBorder badgeText="" tips={content} title={`${LocalT.translate('tips.title')}`} />
      <IncodeFooter>
        <Button
          fullWidth
          label={CTA}
          onClick={() => {
            INCODE_ANALYTICS.INCODE_CTA_CLICK({
              button_label: CTA,
              name: 'incode_overview_clicked',
            });

            history.push(
              {
                pathname: globalThis.location.pathname,
                state: { incode: true },
              },
            );
          }}
        />
      </IncodeFooter>
    </div>
  );
};
